import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import './CompanyPages.css';

const support = [
  ['01', 'いまの業務とシステムを確認', '日々の作業や使っているシステムを確認し、手間がかかるところ、情報が分かれているところを整理します。改善したいことと優先順位を一緒に決めます。'],
  ['02', '業務に合わせたアプリを設計・開発', '使う人と仕事の流れに合わせて、業務アプリや新しいサービスを設計・開発します。必要な機能やデータの扱い方を確認し、実際の運用を考えて形にします。'],
  ['03', 'クラウドへの移行と運用を支援', 'クラウドやサーバーレスの仕組みを使い、システムの構築・移行・運用を支援します。利用状況や管理の負担を踏まえ、業務に合う構成を検討します。'],
  ['04', 'サービスを届ける活動を支援', 'マーケティング戦略から広告運用、PR、SEO、SNSの活用まで。商品やサービスを誰に、どのように届けるかを整理し、デジタル施策の実行を支援します。'],
];

export default function Dx() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const handlePhoneClick = () => {
    const isLocal = ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);
    if (isLocal || typeof window.gtag !== 'function') return;
    window.gtag('event', 'select_content', {
      content_type: 'tel',
      promotions: [{ id: 2, name: 'tel' }],
    });
  };

  return (
    <div className="home">
      <Header />
      <main className="wc-info wc-info-dx" id="first">
        <div className="wc-info-container">
          <div className="wc-info-intro">
            <p className="wc-info-eyebrow">SYSTEM & CLOUD</p>
            <h1>業務システム・クラウド開発</h1>
            <p className="wc-info-lead">仕事の流れに合わせて、システムをつくる。<br className="wc-info-desktop-break" />いまの業務の確認から、アプリ開発、クラウドへの移行・運用まで支援します。</p>
            <div className="wc-info-dx-actions">
              <Link className="wc-info-button" to="/contact">開発・運用について相談する<span aria-hidden="true">→</span></Link>
              <Link className="wc-info-link" to="/service">サービス一覧へ<span aria-hidden="true">→</span></Link>
            </div>
          </div>

          <section className="wc-info-dx-section" aria-labelledby="dx-support-title">
            <p className="wc-info-eyebrow">支援内容</p>
            <h2 id="dx-support-title">必要なところから、一緒に進めます。</h2>
            <div className="wc-info-dx-grid">
              {support.map(([number, title, description]) => (
                <article className="wc-info-dx-card" key={number}>
                  <span className="wc-info-number" aria-hidden="true">{number}</span>
                  <h3>{title}</h3>
                  <p>{description}</p>
                </article>
              ))}
            </div>
          </section>

          <section className="wc-info-dx-video-section" aria-labelledby="dx-video-title">
            <div><p className="wc-info-eyebrow">サービス紹介</p><h2 id="dx-video-title">動画でもご覧いただけます。</h2><p className="wc-info-description">ご興味のある方は、こちらの紹介動画をご覧ください。</p></div>
            <div className="wc-info-dx-video">
              <iframe src="https://www.youtube.com/embed/R59Y1h8ssKg" title="ワンダーコムズのDX・システム開発サービス紹介" loading="lazy" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
            </div>
          </section>

          <section className="wc-info-dx-section" aria-labelledby="dx-work-title">
            <p className="wc-info-eyebrow">過去実績</p>
            <h2 id="dx-work-title">これまでの支援先</h2>
            <div className="wc-info-dx-logos">
              <div><img src={require('../assets/og.png')} alt="DeNA" loading="lazy" /></div>
              <div><img src={require('../assets/company_c2.png')} alt="CyberAgent" loading="lazy" /></div>
              <div><img src={require('../assets/company_r.png')} alt="RECRUIT" loading="lazy" /></div>
            </div>
          </section>

          <aside className="wc-info-contact">
            <div><h2>やりたいことが、まだ曖昧でも大丈夫です。</h2><p>いま困っている作業や、変えたい業務についてお聞かせください。</p></div>
            <Link className="wc-info-button" to="/contact">お問い合わせ<span aria-hidden="true">→</span></Link>
          </aside>
          <div className="wc-info-dx-phone">
            <p>お電話でのお問い合わせ</p>
            <a href="tel:05036275657" onClick={handlePhoneClick}>050-3627-5657</a>
            <p>受付時間：平日9:00〜19:00（12:00〜13:00除く）</p>
          </div>
        </div>
      </main>
    </div>
  );
}
